module.exports = __webpack_public_path__ + "media/images/home/logo-cdf02e24b70bd11fb49f95a9e37bcb25.png";